import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../data/content";

const LINKS = [
  ["Specializations", "#services"],
  ["AIIMS Pedigree", "#pedigree"],
  ["Conditions", "#conditions"],
  ["FAQ", "#faq"],
  ["Stories", "#testimonials"],
  ["Locations", "#locations"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const prefix = window.location.pathname === "/" ? "" : "/";
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FAF8F3]/70 border-b border-[#E3DCCB]/60"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-3">
          <img src="/assets/ircc-logo.png" alt="IRCC Group of Hospitals logo"
            className="w-9 h-9 object-contain rounded-md bg-white p-0.5 border border-[#E3DCCB]" data-testid="nav-logo" />
          <span className="leading-tight">
            <span className="font-serif-display text-lg font-semibold tracking-wide text-stone-800 block">Dr. Siddarth Singh</span>
            <span className="block font-mono-tag text-[10px] uppercase tracking-[0.25em] text-teal-700">DM Pulmonologist · AIIMS</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map(([label, href]) => (
            <a key={href} href={prefix + href} data-testid={`nav-link-${label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-stone-500 hover:text-teal-700 transition-colors duration-300">
              {label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a href={PHONE_TEL} data-testid="nav-call-button"
            className="flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full border border-teal-500/40 text-teal-700 hover:bg-teal-500/10 transition-colors duration-300">
            <Phone size={15} /> Call
          </a>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-button"
            className="flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full bg-[#25D366] text-[#FAF8F3] hover:bg-[#1DA851] transition-colors duration-300">
            <span className="w-2 h-2 rounded-full bg-[#FAF8F3] pulse-dot" />
            <MessageCircle size={15} /> WhatsApp
          </a>
        </div>
        <button className="lg:hidden text-stone-700" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#E3DCCB]/60 px-6 py-4 space-y-4 bg-[#FAF8F3]/95" data-testid="nav-mobile-menu">
          {LINKS.map(([label, href]) => (
            <a key={href} href={prefix + href} onClick={() => setOpen(false)} className="block text-sm text-stone-600 hover:text-teal-700">
              {label}
            </a>
          ))}
          <div className="flex gap-3 pt-2">
            <a href={PHONE_TEL} data-testid="nav-mobile-call" className="flex-1 text-center text-sm px-4 py-2.5 rounded-full border border-teal-500/40 text-teal-700">Call</a>
            <a href={WHATSAPP_URL} data-testid="nav-mobile-whatsapp" className="flex-1 text-center text-sm px-4 py-2.5 rounded-full bg-[#25D366] text-[#FAF8F3] font-medium">WhatsApp</a>
          </div>
        </div>
      )}
    </motion.header>
  );
};
